import {
  FormPageProperty,
  PROPERTY_TYPE,
  SingleSelectionPropertyPulldown,
  SINGLE_SELECTION_PROPERTY_INPUT_TYPE,
  FormPageInputItemSingleSelectionPulldown,
  INPUT_ITEM_TYPE,
  FormPageInputItem,
} from 'shared';

export type SingleSelectionPropertyPulldownWithDrillDown =
  SingleSelectionPropertyPulldown &
    Pick<Required<SingleSelectionPropertyPulldown>, 'drillDown'>;

export const isSingleSelectionPropertyPulldown = (
  property: FormPageProperty | undefined
): property is SingleSelectionPropertyPulldown =>
  property?.propertyType === PROPERTY_TYPE.singleSelection &&
  property.inputFormat.inputType ===
    SINGLE_SELECTION_PROPERTY_INPUT_TYPE.pulldown;

export const isSingleSelectionPropertyPulldownWithDrillDown = (
  property: FormPageProperty | undefined
): property is SingleSelectionPropertyPulldownWithDrillDown =>
  isSingleSelectionPropertyPulldown(property) && property.drillDown != null;

export const isFormPageInputItemSingleSelectionPulldown = (
  formPageInputItem: FormPageInputItem | undefined
): formPageInputItem is FormPageInputItemSingleSelectionPulldown =>
  formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.singleSelectionPulldown;
